import { useEffect, useState } from 'react';
import styled from 'styled-components';
// import Socials from '../../components/ui/organisms/profile/Socials';
import PublicHeaderInfo from '../../components/templates/profile/PublicHeaderInfo';
import PublicAboutMe from '../../components/ui/organisms/profile/PublicAboutMe';
import { useParams } from 'react-router-dom';
import { getPublicProfile } from '../../redux/api/profiles';
import SimpleLoading from '../../components/common/SimpleLoading';
import * as encrypt from 'nodejs-base64-encode';
// import MainProfilePublic from '../../components/templates/profile/MainProfilePublic';
import { titleHTML } from '../../helpers/title.helper';

const PublicProfile = () => {
    titleHTML('Mi perfil público');

    const { id } = useParams();
    const decodeId = encrypt.decode(id + '', 'base64');

    const [user, setUser] = useState(null);

    useEffect(() => {
        // Get user
        getProfile(decodeId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getProfile = async (id) => {
        const request = await getPublicProfile(id);

        console.log('request', request);

        if (request.error) {
            console.log(request.error);
        } else {
            setUser(request);
        }
    };

    if (user === null) {
        return <SimpleLoading />;
    }

    return (
        <ProfileContainer>
            <PublicHeaderInfo
                id={user?.partner_id}
                foto={user?.foto}
                name={user?.name}
                repoId={user?.repo_id}
                sisId={user?.sis_id}
                street={user?.street}
                city={user?.city}
                country={user?.country}
                zip={user?.zip}
                birthday={user?.birthday}
                profession={user?.profession?.name}
                job={user?.current_job?.name}
                personalEmail={user?.personal_email}
                workEmail={user?.work_email}
                phone={user?.phone}
                linkedin={user?.linkedin}
                facebook={user?.facebook}
                instagram={user?.instagram}
                twitter={user?.twitter}
            />
            <Body>
                <PublicAboutMe
                    academicTraining={user?.academic_training}
                    workExperience={user?.work_experience}
                />
            </Body>
        </ProfileContainer>
    );
};

export default PublicProfile;

const ProfileContainer = styled.div`
    display: flex;
    min-height: 100vh;
    box-sizing: border-box;
    gap: 23px;
    padding: 1.5rem 6.5rem;

    @media (max-width: 1024px) {
        padding: 1.5rem;
    }

    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const Body = styled.div`
    flex-basis: 70%;
    height: 100%;
`;
